export const DefaultAuthor = Object.freeze({
  AVATAR_URL: 'https://avatars0.githubusercontent.com/u/?v=3&s=55',
  USERNAME: 'default',
})
